import {gsap} from "gsap/all";
import $ from "jquery";
import * as THREE from "three";
import {GLTFLoader} from "three/addons/loaders/GLTFLoader.js";
import {FaceDistortionMulti} from "./FaceDistortionMulti"
import {FaceLandmarker} from "@mediapipe/tasks-vision";
import {Color} from "three";

export class ThreeJSCameraOverlay {

  constructor({canvas, cameraFeed}) {

    this.width = app.settings.webcam.height;
    this.height = app.settings.webcam.width;
    this.width = 1080;
    this.height = 1920;

    this.renderer = this.createRenderer(canvas);

    this.scene = this.createScene();
    this.sceneCamera = this.createCamera();

    this.overlayScene = this.createScene();
    this.overlayCamera = this.createCamera();

    this.currentSelectedModel = null;
    this.currentSelectedShader = null;

    this.currentShaderModifiersDefaults = {
      leftEyeZoomStrength: 0,
      // rightEyeZoomStrength: 0,
      mouthZoomStrength: 0,
      noseZoomStrength: 0,
      noseSelectedEffect: -1,
      chinSelectedEffect: -1,
    }

    this.currentShaderModifiers = {...this.currentShaderModifiersDefaults}

    const FACEMESH_TESSELATION_INDICES = this.convertEdgesToTriangles(FaceLandmarker.FACE_LANDMARKS_TESSELATION).flat();

    this.hairModels = [
      {
        url: "models/realistic_female_hair.glb",
        scaleFactor: 12, // the higher the bigger
        rotation: {
          x: 2.6,
          y: 0,
          z: 0
        },
        offset: {
          x: 0,
          y: 0.063,
          z: 0
        },
        headObject: "Object_3",
        originOffset: new THREE.Vector3(0, -0.208, -0.1),
        // actualHairMeshName: "Object_2002",
        gltf: null,
        faceModel: null
      },
      {
        url: "models/realistic_long_hair_man.glb",
        scaleFactor: 11, // the higher the bigger
        rotation: {
          x: 2.6,
          y: 0,
          z: 0
        },
        offset: {
          x: 0,
          y: 0.01,
          z: 0.025
        },
        headObject: "Object_5",
        originOffset: new THREE.Vector3(0, -0.26, -0.1),
        gltf: null,
        faceModel: null
      },
      {
        url: "models/realistic_female_hair_curly.glb",
        scaleFactor: 0.1, // the higher the bigger
        rotation: {
          x: 2.7,
          y: 0,
          z: 0
        },
        offset: {
          x: 0,
          y: 0.05,
          z: 0
        },
        headObject: "Object_2",
        originOffset: new THREE.Vector3(0, -20, -10),
        gltf: null,
        faceModel: null
      },
    ]

    this.models = [
      {
        url: "models/dolores_the_cat.glb",
        scaleFactor: 0.0125, // the higher the bigger
        rotation: {
          x: 2.6,
          y: 0,
          z: 0
        },
        offset: {
          x: 0,
          y: 0.105,
          z: 0
        },
        originOffset: new THREE.Vector3(0, 100, -20),
        gltf: null,
        faceModel: null
      },
      {
        url: "models/sunflower.glb",
        scaleFactor: 1.75, // the higher the bigger
        rotation: {
          x: 2.6,
          y: 0,
          z: 0
        },
        offset: {
          x: 0,
          y: 0,
          z: 0
        },
        originOffset: new THREE.Vector3(0, 0, 0.4),
        gltf: null,
        faceModel: null
      },
      {
        url: "models/gorilla_v2.glb",
        scaleFactor: 0.0125, // the higher the bigger
        rotation: {
          x: 2.6,
          y: 0,
          z: 0
        },
        offset: {
          x: 0,
          y: 0,
          z: -0.1
        },
        originOffset: new THREE.Vector3(0, 70, -20),
        gltf: null,
        faceModel: null
      }
    ];

    // Camera texture we can pass to the shaders
    this.shaderCameraTexture = new THREE.CanvasTexture(cameraFeed);
    this.shaderCameraTexture.minFilter = THREE.LinearFilter;
    this.shaderCameraTexture.magFilter = THREE.LinearFilter;

    this.faceDebugMode = false;
    this.normalizedFaceLandmarks = []; // to be used in 3D space (like for the models)
    this.pixelizedFaceLandmarks = []; // to be used in 2D space (like for the distortion shaders)
    this.normalizedMainFaceLandmarks = []; // to be used in 3D space (like for the models)
    this.pixelizedMainFaceLandmarks = []; // to be used in 2D space (like for the distortion shaders)
    this.facePointsPositions = null;
    this.faceLandmarksCounts = 478;
    this.faceGeometry = new THREE.BufferGeometry();
    this.faceGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(this.faceLandmarksCounts * 3), 3));
    this.faceGeometry.setIndex(FACEMESH_TESSELATION_INDICES);

    // Basic shader material without shader deformation used by default
    this.shaderNormalMat = new THREE.MeshBasicMaterial({map: this.shaderCameraTexture});

    // ====  This is the part fo the Plane Mesh
    this.shaderGeom = new THREE.PlaneGeometry(2, 2);
    this.shaderMesh = new THREE.Mesh(this.shaderGeom, this.shaderNormalMat);
    this.shaderMesh.position.set(0, 0, 0);
    this.scene.add(this.shaderMesh);

    this.shaders = {
      deformationMulti: new FaceDistortionMulti({texture: this.shaderCameraTexture}), // TO BE USED WITH PLANE GEOMETRY
    }

    this.currentSelectedShader = this.shaders.deformationMulti;
    this.shaderMesh.material = this.currentSelectedShader;
    this.shaderMesh.material.depthWrite = false;  // plane won’t block anything
    this.shaderMesh.material.depthTest = false;   // plane doesn’t check depth

    this.headMaskMaterial = new THREE.MeshBasicMaterial({
      colorWrite: false,   // do not render color
      transparent: true,
      side: THREE.DoubleSide,
    });

    this.faceMaskMesh = new THREE.Mesh(this.faceGeometry, this.headMaskMaterial);
    this.faceMaskMesh.renderOrder = 1;
    this.faceMaskMesh.scale.set(0.95, 1.25, 1); // stretch the face mask a bit to cover more of the forehead and neck to mask the hair
    this.faceMaskMesh.position.set(0, 0.025, 0); // pull the face up so it fits more in the hair

    this.overlayScene.add(this.faceMaskMesh);

    this.faceModel = null;

    this.ready = false;

    this.init();
  }

  createRenderer(canvas) {
    let renderer = new THREE.WebGLRenderer({canvas, antialias: true, alpha: true});
    renderer.setSize(this.width, this.height);
    renderer.setPixelRatio(1.0);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    return renderer;
  }

  createScene() {
    let scene = new THREE.Scene();

    const ambient = new THREE.AmbientLight(0xffffff, 0.3);
    scene.add(ambient);

    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 1.0);
    hemiLight.position.set(0, 1, 0);
    scene.add(hemiLight);

    const dir = new THREE.DirectionalLight(0xffffff, 1.25);
    dir.position.set(3, 10, 10);
    scene.add(dir);

    const dir2 = new THREE.DirectionalLight(new Color(0.6, 0.8, 0.2), 0.7);
    dir2.position.set(3.2, 10, 10);
    dir2.visible = false;
    scene.add(dir2);
    this.optionalLight = dir2;

    return scene;
  }

  createCamera() {
    const aspect = this.width / this.height;
    let camera = new THREE.PerspectiveCamera(70, aspect, 0.01, 2000000);
    camera.position.z = 1;
    camera.updateProjectionMatrix();

    return camera;
  }

  init() {
    (async () => {
      await this.loadAssets();
    })();

    // window.addEventListener('keydown', (event) => {
    //   if (event.key === 'd') {
    //     this.faceDebugMode = !this.faceDebugMode;
    //   }
    // });
  }

  // Load GLTF file with promise
  loadGLTF(model) {
    return new Promise((resolve, reject) => {
      console.log(`Loading ${model.url}...`);

      const loader = new GLTFLoader();

      loader.load(model.url, (gltf) => {
        resolve(gltf);
      });
    });

  }

  async loadAssets() {
    // Convert list of models into an array of Promises so we can load them all and know when all are done
    let promises = Object.entries(this.models).map(async ([key, model]) => {
      const gltf = await this.loadGLTF(model);
      return {key, gltf};
    });

    // Wait for all to finish
    let results = await Promise.all(promises);

    // Now let's save the model data into our main object
    results.map(({key, gltf}) => {
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.position.copy(this.models[key].originOffset);

          // Helper to place the model correctly
          // child.material.transparent = true;
          // child.material.opacity = 0.2
        }
      });

      this.models[key].gltf = gltf;
      this.models[key].faceModel = gltf.scene;
      this.models[key].faceModel.visible = false;

      // Helper to place the model correctly
      // this.models[key].faceModel.add(new THREE.AxesHelper(200));
    })

    // Load hair assets
    promises = Object.entries(this.hairModels).map(async ([key, model]) => {
      const gltf = await this.loadGLTF(model);
      return {key, gltf};
    });

    // Wait for all to finish
    results = await Promise.all(promises);

    // Now let's save the model data into our main object
    results.map(({key, gltf}) => {
      // Ensure all hair cards are double-sided and transparent

      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          // Make sure to hide the head model inside the glb file
          if (child.name == this.hairModels[key].headObject) {
            child.visible = false;
          }

          child.material.transparent = true;       // alpha for hair cards
          child.material.opacity = 1;       // alpha for hair cards
          child.material.alphaTest = 0.01;         // discard fully transparent fragments
          child.renderOrder = 2;                   // after head
        }
      });

      this.hairModels[key].faceModel = gltf.scene;
      this.hairModels[key].faceModel.children[0].position.copy(this.hairModels[key].originOffset);

      this.hairModels[key].gltf = gltf;
    })

  }

  updateFaceLandmarks(landmarks, mainFaceLandmarks) {
    this.normalizedFaceLandmarks = this.normalizeLandmarks(landmarks);
    this.pixelizedFaceLandmarks = this.pixelizeLandmarks(landmarks);
    this.normalizedMainFaceLandmarks = this.normalizeLandmarks(mainFaceLandmarks);
    this.pixelizedMainFaceLandmarks = this.pixelizeLandmarks(mainFaceLandmarks);

    if (this.normalizedFaceLandmarks.length > 0) {
      // Update the points geometry
      const positions = this.faceGeometry.getAttribute("position");
      const positionsArr = positions.array

      this.normalizedFaceLandmarks.forEach((p, i) => {
        if (app.level3.partsIndexes.LEFT_EYE_CONTOUR.includes(i)) {
          let leftEyeCenter = this.normalizedMainFaceLandmarks.find(lm => lm.name === "left_eye");
          positionsArr[i * 3] = leftEyeCenter.x;
          positionsArr[i * 3 + 1] = leftEyeCenter.y;
          positionsArr[i * 3 + 2] = leftEyeCenter.z;

        } else if (app.level3.partsIndexes.RIGHT_EYE_CONTOUR.includes(i)) {
          let rightEyeCenter = this.normalizedMainFaceLandmarks.find(lm => lm.name === "eye");
          positionsArr[i * 3] = rightEyeCenter.x;
          positionsArr[i * 3 + 1] = rightEyeCenter.y;
          positionsArr[i * 3 + 2] = rightEyeCenter.z;

        } else if (app.level3.partsIndexes.MOUTH_CONTOUR.includes(i)) {
          let mouthCenter = this.normalizedMainFaceLandmarks.find(lm => lm.name === "mouth");
          positionsArr[i * 3] = mouthCenter.x;
          positionsArr[i * 3 + 1] = mouthCenter.y;
          positionsArr[i * 3 + 2] = mouthCenter.z;

        } else {
          positionsArr[i * 3] = p.x;
          positionsArr[i * 3 + 1] = p.y;
          positionsArr[i * 3 + 2] = p.z;

        }
      });

      positions.needsUpdate = true;
      this.faceMaskMesh.geometry.computeBoundingSphere();
      this.faceMaskMesh.geometry.computeVertexNormals();

      const {position, quaternion, scale, faceAngles} = this.estimateHeadPose(this.normalizedFaceLandmarks);

      const faceScale = scale.clone();

      // Let's update the matrix with the current model base info so we can scale the
      // models differently to match the face
      if (this.currentSelectedModel !== null && this.faceModel !== null) {
        position.x += this.currentSelectedModel.offset.x;
        position.y += this.currentSelectedModel.offset.y;
        position.z += this.currentSelectedModel.offset.z;

        // Fix the orientation to make sure the model is facing forward
        const correction = new THREE.Quaternion().setFromEuler(new THREE.Euler(this.currentSelectedModel.rotation.x, this.currentSelectedModel.rotation.y, this.currentSelectedModel.rotation.z));
        quaternion.multiply(correction);

        scale.multiplyScalar(this.currentSelectedModel.scaleFactor);

        // Use lerp to smooth out the head movement to be more fluid instead of using position directly
        this.faceModel.position.lerp(position, 0.8);
        this.faceModel.scale.lerp(scale, 0.8);
        this.faceModel.quaternion.slerp(quaternion, 0.8);

        this.currentSelectedModel.faceModel.traverse((child) => {
          if (child.isMesh) {
            child.material.transparent = true;
            child.material.opacity = THREE.MathUtils.lerp(child.material.opacity, 1, 0.25);
          }
        })
      }

      // Here we can update the shaders depending on the route we go
      // For now as all the shaders are a bit different, we'll check if the uniform actually exists before setting it or it will break

      if (this.currentSelectedShader.uniforms.hasOwnProperty('headYaw')) {
        this.currentSelectedShader.uniforms.headYaw.value = faceAngles.yaw;
      }

      if (this.currentSelectedShader.uniforms.hasOwnProperty('headRoll')) {
        this.currentSelectedShader.uniforms.headRoll.value = faceAngles.roll;
      }

      if (this.currentSelectedShader.uniforms.hasOwnProperty('headPitch')) {
        this.currentSelectedShader.uniforms.headPitch.value = faceAngles.pitch;
      }

      // Set the left and right eye positions in the shader so we can make them bigger or something
      if (this.currentSelectedShader.uniforms.hasOwnProperty('leftEye')) {
        const leftEyePos = this.pixelizedMainFaceLandmarks.find(lm => lm.name === "left_eye");
        const leftEye = new THREE.Vector2(leftEyePos.x, leftEyePos.y);
        this.currentSelectedShader.uniforms.leftEye.value.copy(leftEye);
        this.currentSelectedShader.uniforms.leftEyeZoomStrength.value = this.currentShaderModifiers.leftEyeZoomStrength;
      }


      //
      // if (this.currentSelectedShader.uniforms.hasOwnProperty('rightEye')) {
      //   const rightEyePos = this.pixelizedMainFaceLandmarks.find(lm => lm.name === "eye");
      //   const rightEye = new THREE.Vector2(rightEyePos.x, rightEyePos.y);
      //   this.currentSelectedShader.uniforms.rightEye.value.copy(rightEye);
      //   this.currentSelectedShader.uniforms.rightEyeZoomStrength.value = this.currentShaderModifiers.rightEyeZoomStrength;
      // }

      if (this.currentSelectedShader.uniforms.hasOwnProperty('nose')) {
        const nosePos = this.pixelizedMainFaceLandmarks.find(lm => lm.name === "nose");
        const nose = new THREE.Vector2(nosePos.x, nosePos.y);
        this.currentSelectedShader.uniforms.nose.value.copy(nose);
        this.currentSelectedShader.uniforms.noseSelectedEffect.value = this.currentShaderModifiers.noseSelectedEffect;
        this.currentSelectedShader.uniforms.noseZoomStrength.value = this.currentShaderModifiers.noseZoomStrength;
      }

      // if (this.currentSelectedShader.uniforms.hasOwnProperty('mouth')) {
      //   const mouthPos = this.pixelizedMainFaceLandmarks.find(lm => lm.name === "mouth");
      //   const mouth = new THREE.Vector2(mouthPos.x, mouthPos.y);
      //   this.currentSelectedShader.uniforms.mouth.value.copy(mouth);
      //   this.currentSelectedShader.uniforms.mouthZoomStrength.value = this.currentShaderModifiers.mouthZoomStrength;
      // }

      if (this.currentSelectedShader.uniforms.hasOwnProperty('chin')) {
        const chinPos = this.pixelizedMainFaceLandmarks.find(lm => lm.name === "chin");
        const chin = new THREE.Vector2(chinPos.x, chinPos.y);
        this.currentSelectedShader.uniforms.chin.value.copy(chin);
        this.currentSelectedShader.uniforms.chinSelectedEffect.value = this.currentShaderModifiers.chinSelectedEffect;
        this.currentSelectedShader.uniforms.chinZoomStrength.value = this.currentShaderModifiers.chinZoomStrength;
      }

      // send face positions to the shader

      // // Here is a square bouding box of the face if we want to alter the shape somehow and follow the head
      // if (this.currentSelectedShader.uniforms.hasOwnProperty('faceBoundingBox')) {
      //   // Here I tried to get a bounding box for the forhead to try to make it bigger in the shader
      //   const headBoundingBox = this.getHeadBoundingBox(this.pixelizedFaceLandmarks);
      //   this.currentSelectedShader.uniforms.faceBoundingBox.value = new THREE.Vector4(headBoundingBox.x, headBoundingBox.y, headBoundingBox.w, headBoundingBox.h);
      // }

      // // Face center point, if used
      // if (this.currentSelectedShader.uniforms.hasOwnProperty('faceCenter')) {
      //   this.currentSelectedShader.uniforms.faceCenter.value.copy(position);
      // }
      //
      // Face scaling if you want to adapt the effect based on the head distance from the camera to follow the head more precisely
      if (this.currentSelectedShader.uniforms.hasOwnProperty('faceScale')) {
        this.currentSelectedShader.uniforms.faceScale.value = faceScale.x;
      }

    } else {
      // No face detected, make sure the 3d models are hidden
      if (this.currentSelectedModel !== null && this.faceModel !== null) {
        this.currentSelectedModel.faceModel.traverse((child) => {
          if (child.isMesh) {
            child.material.transparent = true;
            child.material.opacity = THREE.MathUtils.lerp(child.material.opacity, 0, 0.25);
          }
        })
      }
    }

  }

  animate(time) {
    if (!this.ready) {
      return;
    }

    if (this.shaderMesh.visible) {
      if (this.currentSelectedShader.uniforms.hasOwnProperty('iTime')) {
        this.currentSelectedShader.uniforms.iTime.value = time;
      }

      this.shaderCameraTexture.needsUpdate = true;
    }

    this.renderer.render(this.scene, this.sceneCamera);
    this.renderer.autoClear = false;
    this.renderer.clearDepth();
    this.renderer.render(this.overlayScene, this.overlayCamera);
    this.renderer.autoClear = true;
  }

  normalizeLandmarks(landmarks) {
    return landmarks.map(p => ({
      ...p,
      x: (p.x - 0.5), // center X
      y: -(p.y - 0.5) * 1.6, // center and flip Y. We'll also scale Y to fit the face correctly
      z: -p.z - 0.15, // flip Z so closer is positive (optional)
    }));
  }

  pixelizeLandmarks(landmarks) {
    return landmarks.map(p => ({
      ...p,
      x: p.x * this.width, // convert to pixel space coord
      y: this.height - (p.y * this.height), // convert to pixel space coord and flip
    }));
  }

  estimateHeadPose(landmarks) {
    if (landmarks.length == 0) {
      const position = new THREE.Vector3(0, 0, 0);
      const quaternion = new THREE.Vector3(0, 0, 0);
      const scale = new THREE.Vector3(0, 0, 0);
      const faceAngles = new THREE.Vector3(0, 0, 0);
      return {position, quaternion, scale, faceAngles};
    }

    const nose = new THREE.Vector3(landmarks[1].x, landmarks[1].y, landmarks[1].z);
    const leftEye = new THREE.Vector3(landmarks[33].x, landmarks[33].y, landmarks[33].z);
    const rightEye = new THREE.Vector3(landmarks[263].x, landmarks[263].y, landmarks[263].z);
    const chin = new THREE.Vector3(landmarks[152].x, landmarks[152].y, landmarks[152].z);

    // We'll position the model at the nose position so it should be quite centered in the face
    const position = nose.clone();

    // Compute approximate axes
    const xAxis = new THREE.Vector3().subVectors(rightEye, leftEye).normalize();  // left right
    const yAxis = new THREE.Vector3().subVectors(chin, nose).normalize();         // nose chin
    const zAxis = new THREE.Vector3().crossVectors(xAxis, yAxis).normalize();     // forward

    // Re-orthogonalize
    const correctedXAxis = new THREE.Vector3().crossVectors(yAxis, zAxis).normalize();
    const correctedYAxis = new THREE.Vector3().crossVectors(zAxis, correctedXAxis).normalize();
    const correctedZAxis = zAxis;

    // Build rotation matrix
    const rotMat = new THREE.Matrix4();
    rotMat.makeBasis(correctedXAxis, correctedYAxis, correctedZAxis);
    const quaternion = new THREE.Quaternion().setFromRotationMatrix(rotMat);

    // 2D head angle to pass to the shader
    const faceAngles = {
      roll: Math.atan2(correctedXAxis.y, correctedXAxis.x),
      yaw: Math.atan2(correctedZAxis.x, correctedZAxis.z),
      pitch: Math.asin(-correctedZAxis.y),
    }

    // Add scaling based on eye distance
    const eyeDistance = leftEye.distanceTo(rightEye);
    const scale = new THREE.Vector3(eyeDistance, eyeDistance, eyeDistance);

    // Return the position and rotation
    return {position, quaternion, scale, faceAngles};
  }

  getHeadBoundingBox(landmarks) {
    if (!landmarks || landmarks.length === 0) return null;

    let xMin = 1, yMin = 1, xMax = 0, yMax = 0;

    for (const lm of landmarks) {
      xMin = Math.min(xMin, lm.x);
      yMin = Math.min(yMin, lm.y);
      xMax = Math.max(xMax, lm.x);
      yMax = Math.max(yMax, lm.y);
    }

    return {
      x: xMin,
      y: yMin,
      w: xMax - xMin,
      h: yMax - yMin
    };
  }

  play() {
    gsap.set(this.renderer.domElement, {
      autoAlpha: 1,
      overwrite: "all",
    });

    this.ready = true;

    this.renderer.setAnimationLoop((time) => {
      this.animate(time)
    });
  }

  pause() {
    gsap.to(this.renderer.domElement, {
      autoAlpha: 0,
      delay: 1,
      duration: 0.25,
      overwrite: "all",
    });

    this.ready = false;

    this.renderer.setAnimationLoop(null);
  }

  selectEffect(facePart, adnSelected, completed) {
    // Let's get a random model and assign it to our faceModel


    this.shaderMesh.material = this.currentSelectedShader;

    // Based on the facePart, we'll update the transformation
    // forehead -> hair model
    // nose -> nose shader deformation
    // chin -> chin shader deformation

    // The adn number affect the transformation

    console.log(`facePart: ${facePart}`, `adnSelected: ${adnSelected}`, `completed? ${completed} (if completed, would show full face model`);

    // If completed, instead load a complete face model to cover all the face and reset transformations
    if (completed) {

      // Reset a few things first
      if (this.faceModel !== null) {
        this.overlayScene.remove(this.faceModel);
        this.faceModel = null;
      }

      // Let's select a full face model and reset the other transformations
      this.currentSelectedModel = this.models[adnSelected];
      this.faceModel = this.currentSelectedModel.faceModel;
      this.faceModel.visible = true;
      this.overlayScene.add(this.faceModel);

      const {scale} = this.estimateHeadPose(this.normalizedFaceLandmarks);
      scale.multiplyScalar(this.currentSelectedModel.scaleFactor);
      // set scale immediately so there is not a flash of the big model before showing up
      // I use lerp with 1.0 so it triggers immediately, because somehow if I use "set" it doesn't work as expected
      this.faceModel.scale.lerp(scale, 1.0);

      this.currentShaderModifiers = {
        ...this.currentShaderModifiersDefaults,
        noseSelectedEffect: -1,
        chinSelectedEffect: -1,
      }

    } else {
      if (facePart === "forehead") {
        // Reset a few things first
        if (this.faceModel !== null) {
          this.overlayScene.remove(this.faceModel);
          this.faceModel = null;
        }

        this.currentSelectedModel = this.hairModels[adnSelected];
        this.faceModel = this.currentSelectedModel.faceModel;
        this.faceModel.visible = true;
        this.overlayScene.add(this.faceModel);

        // Enable optional light for some models
        this.optionalLight.visible = (adnSelected === 2)

      } else if (facePart === "nose") {
        this.currentShaderModifiers.noseSelectedEffect = adnSelected;

      } else if (facePart === "chin") {
        this.currentShaderModifiers.chinSelectedEffect = adnSelected;

      }
    }
  }

  convertEdgesToTriangles(edges) {
    const triangles = [];
    for (let i = 0; i < edges.length; i += 3) {
      const a = edges[i]?.start;
      const b = edges[i + 1]?.start;
      const c = edges[i + 2]?.start;
      if (a !== undefined && b !== undefined && c !== undefined) {
        triangles.push([a, b, c]);
      }
    }
    return triangles;
  }

  reset() {
    // TODO
    this.pause();

    if (this.faceModel !== null) {
      this.overlayScene.remove(this.faceModel);
      this.faceModel = null;
    }

    this.currentShaderModifiers = {...this.currentShaderModifiersDefaults}
  }

  randomExcluded(min1, max1, min2, max2) {
    // randomly pick between range 1 and range 2
    return Math.random() < 0.5
      ? Math.random() * (max1 - min1) + min1
      : Math.random() * (max2 - min2) + min2;
  }


}
